"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _stringify = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/json/stringify"));

var _typeof2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/typeof"));

require("core-js/modules/web.dom.iterable");

require("core-js/modules/es6.array.iterator");

var _getIterator2 = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/get-iterator"));

function serializeObject(data) {
  var params = [];
  var _iteratorNormalCompletion = true;
  var _didIteratorError = false;
  var _iteratorError = undefined;

  try {
    for (var _iterator = (0, _getIterator2.default)(Object.keys(data)), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
      var key = _step.value;
      var value = data[key]; // stringify 过滤掉undefined和null

      if (value !== null && value !== void 0) {
        if ((0, _typeof2.default)(value) === 'object') {
          params.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent((0, _stringify.default)(value))));
        } else {
          params.push("".concat(encodeURIComponent(key), "=").concat(encodeURIComponent(value)));
        }
      }
    }
  } catch (err) {
    _didIteratorError = true;
    _iteratorError = err;
  } finally {
    try {
      if (!_iteratorNormalCompletion && _iterator.return != null) {
        _iterator.return();
      }
    } finally {
      if (_didIteratorError) {
        throw _iteratorError;
      }
    }
  }

  return params.join('&');
}

serializeObject.default = serializeObject;
var _default = serializeObject;
exports.default = _default;
module.exports = exports["default"];